import { Fragment, h, JSX } from 'preact';

import { OrderSummary, OrderSummaryProps } from './OrderSummary';
import { GridView, GridViewProps } from './GridView';
import {TicketView, TicketViewProps} from './TicketView'
import { OpenGiftCardModal, OpenGiftCardModalProps } from './OpenGiftCardModal';
import classNames from 'classnames';

export interface TicketOfficeProps {
    orderSummary: OrderSummaryProps;
    gridView?: GridViewProps;
    ticketView?: TicketViewProps;
    openGiftCardModal?: OpenGiftCardModalProps;
}

export const TicketOffice = (props: TicketOfficeProps): JSX.Element => (
    <Fragment>
        <div class='flex-1 p-4 pt-0 md:pt-8 xl:p-12'>
            {props.gridView && <GridView {...props.gridView}/>}
            {props.ticketView && <TicketView {...props.ticketView}/>}
        </div>
        <div class='basis-96 shrink-0'>
            <OrderSummary {...props.orderSummary} />
        </div>
        {props.openGiftCardModal && <OpenGiftCardModal {...props.openGiftCardModal} />}
    </Fragment>
);
